<template>
  <div class="job-detail">
    <h1 class="job-detail-title">{{ jobDetail.name }}</h1>
    <div class="job-detail-subTitle" v-if="jobDetail.id">
      <span class="city_info">{{ jobDetail.zsLevel.name }}</span
      >&nbsp;|
      <span class="job_category">{{ jobDetail.shipType.name}}</span
      >&nbsp;|
      <span class="recruit_type" style="color:red;">{{ jobDetail.salary }}</span>
   
    </div>
    <div class="job-detail-description job-detail-block">
      <h2>职位描述</h2>
      <pre class="textContent">{{ jobDetail.intro }}</pre>
    </div>
    <div class="job-detail-requirement job-detail-block">
      <h2>职位要求</h2>
      <pre class="textContent">需求职位：{{ jobDetail.name }}</pre>
      <pre class="textContent">证书等级：{{ jobDetail.zsLevel.name }}</pre>
       <pre class="textContent">航区：{{ jobDetail.zsHq.name }}</pre>
        <pre class="textContent">船舶类型：{{ jobDetail.shipType.name }}</pre>
         <pre class="textContent">船舶吨位：{{ jobDetail.shipTLevel.name }}</pre>
    </div>
    <div>
      <h2>标签</h2>
      <div v-for="(tag, index) in jobDetail.tag" :key="index" >
          <span>{{tag.name}}</span>
      </div>        
    </div>
   
    <div class="job-detail-description job-detail-block">
       <h2>联系人</h2>
      <pre class="textContent">联系人：{{jobDetail.contact}}&nbsp;&nbsp;&nbsp;Tel：{{jobDetail.contactMobile}}
      </pre>
    </div>
    <hr>
    <div>
       <router-link :to="`/enterprise/${jobDetail.company.uid}`">
      <pre class="textContent">{{jobDetail.company.nickname}}&nbsp;&nbsp;&nbsp;在招职位：{{jobDetail.company.jobCount}}&nbsp;&nbsp;&nbsp;{{ jobDetail.created_at }}更新
      </pre>
       </router-link>
    </div>
    <div class="job-detail-button job-detail-block">
      <bytedance-button @click="delivery" size="large">投递</bytedance-button>
    </div>
  </div>
</template>
<script>
import {
fetchJobDetail,
fetchJobApply
} from "@/helper/requestWithToken.js";
import { state } from "@/store";
export default {
  name: "job-detail",
  data() {
    return { jobDetail: {} };
  },

  methods: {
    delivery() {
      if (!state.isLogin) {
        console.log("点击投递,用户未登录");
        this.$router.push("/user");
      } else {
        console.log("点击投递,用户已登录");
        //this.$message.success("功能开发中...");
        let loading = this.$loading({ position: { top: 60 } });
        let applydata=this.$route.params;
        fetchJobApply(applydata)
          .then(res =>{
            console.log(res);
            if(res.code !='200'){
              this.$message.error(res.msg);
            }else{
              this.$message.success("简历已投递");
            }
            loading.close();
          })
          .catch(loading.close)
        //用户信息投递访问 需携带用户token
      }
    }
  },
  created() {
    let loading = this.$loading({ position: { top: 60 } });
    const { id } = this.$route.params;
    fetchJobDetail(id)
      .then(res => {
        console.log(res);
        this.jobDetail = res.data;
        console.log(this.jobDetail.name);
        loading.close();
      })
      .catch(loading.close);
  }
};
</script>
<style lang="less" scoped>
.job-detail {
  width: 800px;

  margin: auto;
  margin-top: 100px;
  line-height: 2em;
  &-subTitle {
    font-size: @font-size-base;
    color: @primary-text-color;
    margin: 20px 0;
  }
  &-description {
    .textContent {
      white-space: pre-line;
    }
  }
  &-block {
    h2 {
      margin-bottom: 20px;
    }
    margin: 40px 0;
    .textContent {
      font-size: @font-size-base;
      color: @primary-text-color;
    }
  }
  &-button {
    width: 200px;
  }
  &-hr {
    width:"80%"; 
    color:#987cb9; 
    SIZE:3;
  } 
}
</style>
